export const API_COLORS = {
  PRIMARY: 'rgb(51 167 11 / 98%)',
  SUCCESS: '#28a745',
  DANGER: '#dc3545',
  WARNING: '#ffc107',
  INFO: '#17a2b8',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
  WHITE: '#ffffff',
  BLACK: '#000000',
  PLUS_ZERO: '#000000',
};

export const STATUS_COLORS = {
  PENDING: '#ffc107',
  APPROVED: '#28a745',
  REJECTED: '#dc3545',
  ACTIVE: '#007bff',
  INACTIVE: '#6c757d',
};
